angular.module('SpidApp')

.factory('ProductService',
[        'Product', 'Restangular', 'SPID_CONFIG',
function (Product,   Restangular,   SPID_CONFIG) {
	var ProductService = {
		all: function () {
			var now = new Date()
			
			return Restangular.all('products').getList().then(function (productsData) {
				if (SPID_CONFIG.mocks.products.isMocked === true) {
					productsData = SPID_CONFIG.mocks.products.value
				}
				
				var products = _.chain(productsData).filter(function (product) {
					return new Date(product.date_used) < now
				}).sortBy('date_used').groupBy('id').mapObject(function (v) {
					return v[0]
				}).map(function (sub) {
					return new Product(sub)
				}).value()
				
				return products
			})
		}
	}

	return ProductService
}])